function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#8DC351"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55.7943 19.1603C54.2227 15.1665 50.2816 14.806 45.6923 15.6971L44.0579 10L40.5906 10.9944L42.1825 16.5437C41.2711 16.8029 40.3435 17.0905 39.422 17.374L37.8221 11.7883L34.3568 12.7807L35.9872 18.4778C35.2419 18.7087 34.5087 18.9355 33.7898 19.1421L33.7837 19.1218L29 20.4929L30.0633 24.1992C30.0633 24.1992 32.6111 23.4134 32.5807 23.4741C33.9862 23.0711 34.6768 23.7556 35.011 24.422L36.8743 30.9109C36.9694 30.8846 37.097 30.8522 37.2469 30.8299L36.8803 30.9352L39.4869 40.0287C39.5517 40.4884 39.495 41.2682 38.5147 41.5517C38.5694 41.578 35.9912 42.2727 35.9912 42.2727L36.4915 46.6129L41.0038 45.3167C41.8443 45.0797 42.6746 44.857 43.4868 44.6281L45.1414 50.39L48.6046 49.3976L46.9702 43.6965C47.8992 43.45 48.8255 43.1934 49.7489 42.9269L51.3732 48.6037L54.8425 47.6093L53.1939 41.8575C58.9274 39.8505 62.5871 37.2116 61.5238 31.5894C60.6692 27.0649 58.0323 25.6918 54.4941 25.8457C56.2115 24.2458 56.9508 22.0828 55.7943 19.1623V19.1603ZM54.4779 32.8714C55.7133 37.1792 48.1996 38.8034 45.8503 39.4799L43.6609 31.8446C46.0103 31.1702 53.1878 28.3814 54.4759 32.8734L54.4779 32.8714ZM49.7752 22.5628C50.8972 26.4817 44.6169 27.788 42.6584 28.349L40.6737 21.4246C42.6301 20.8636 48.6026 18.4778 49.7752 22.5648V22.5628Z",
  fill: "white"
});

var SvgBch = function SvgBch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BCH.078914e5.svg";
export { ForwardRef as ReactComponent };